import type { AnswerValue } from '../../sports/domains/what-an-answer-holds';
export class SetUserLevelSportAction {
  static readonly type = '[UserSports] SetUserLevelSportAction';

  constructor(
    public payload: {
      sportId: string;
      /**
       * The discipline this level is for (= session-kind id), on sports assessed
       * per discipline (ski). Absent on single-level sports, where the level is
       * the sport's own.
       */
      disciplineId?: string;
      level: number;
      answerSentence: string;
      answers: {
        questionId: string;
        /**
         * A string or a number, and both really travel.
         *
         * The numeric and time questions emit numbers, `any` carried them all
         * the way here unexamined, and they reach the API as JSON numbers even
         * though its DTO declares a string. That is not speculation: the
         * migration 20260810120000-update-running-and-cycling-sport-levels.ts
         * declares `answer?: string | number` precisely because the collection
         * already holds both.
         *
         * Declared rather than coerced: turning numbers into strings here
         * would change what is sent and what is stored, which is a decision
         * about data and not about types.
         */
        answer: AnswerValue;
      }[];
      /** Where the sport was declared from. Analytics only, never persisted. */
      source?: 'onboarding' | 'profile_edit' | 'nudge';
    },
  ) {}
}

export class DeleteLevelSportAction {
  static readonly type = '[UserSports] DeleteLevelSportAction';

  constructor(public payload: { sportId: string }) {}
}
